import { defineComponent, toRefs, PropType, ref, computed } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, FullNormalFormData, AcoFormData } from '@tt4b/ttam-enums';
import formItemRejectReason from '@/components/common/form-item-reject-reason/index.vue';
import { useCreativeFallBackValidate, useFallbackFormStatus } from '@tt4b/ttam-hooks';

import CreativeDeepLink from '../index';

const name = 'ttam-creative-fallback-compose';
export default defineComponent({
  name,
  components: {
    formItemRejectReason,
    TtamCreativeDeepLinkFallbackInput: CreativeDeepLink.TtamCreativeDeepLinkFallbackInput,
    TtamCreativeDeepLinkFallbackType: CreativeDeepLink.TtamCreativeDeepLinkFallbackType,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    rejectReason: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, creativeData } = toRefs(props);

    const _fallbackType = computed({
      get: () => {
        console.log('getgetgetgetget', creativeData.value.fallbackType);
        return creativeData.value.fallbackType;
      },
      set: val => {
        emit('fallback-type-change', val);
      },
    });

    const _fallbackUrl = computed({
      get: () => creativeData.value.externalUrl,
      set: val => {
        emit('fallback-url-change', val);
      },
    });

    const commonProps = {
      adgroupData,
      campaignData,
      creativeData,
    };

    const { fallBackTypeValidator, fallBackUrlValidator } = useCreativeFallBackValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });

    const { isShowFallbackType: fallbackVisible, isShowFallbackCustomUrl: fallbackUrlVisible } = useFallbackFormStatus({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
      creativeFormData: creativeData,
    });

    const { options: fallbackTypeOptions } = CreativeDeepLink.useFallBackTypePropsOptions(commonProps);

    const { label: fallbackTypeLabel } = CreativeDeepLink.useFallBackTypePropsLabel(commonProps);

    return {
      name,
      _fallbackType,
      _fallbackUrl,

      fallBackTypeValidator,
      fallBackUrlValidator,

      fallbackVisible,
      fallbackUrlVisible,
      fallbackTypeOptions,
      fallbackTypeLabel,
    };
  },
});
